import { Div } from "../../../../../base/components/native/div"
import { Input } from "../../../../../base/components/native/input"
import { editorStyle } from "./faqs.style"

export const FAQEditor = () => {

    const base = Div()
    const _editor = Input('', 'textarea')
    base.append(_editor)
    _editor.cssClass(editorStyle)
    let E: any
    _editor.on('mounted', () => {
        try {

            E = (window.SUNEDITOR as any)?.create(_editor.el, {
                defaultStyle: 'font-family: Persian; font-size: 16px;  word-spacing: 2px; line-height: 1.5;',
                height: '240px',
                strictMode: true, // Prevents unnecessary tags and styles
                resizingBar: false,
                showPathLabel: false,
                pasteTagsWhitelist: 'p|ul|li|strong|em|a',
                rtl: true,
                buttonList: [
                    [
                        'blockquote', 'bold', 'underline', 'italic', 'strike',
                        'fontColor', 'hiliteColor', 'horizontalRule', 'list', 'outdent', 'indent',
                        'table', 'link', 'image', 'video', 'dir', 'removeFormat', 'codeView'
                    ]
                ],
                imageUploadUrl: '/data/images/upload-site',

            })
            E.onChange = (contents: any) => {
                console.log('change', contents);
                base.emit('change', contents)
            }
        } catch (error) {
            console.log('error', error);
        }

    })


    return Object.assign(base, {
        getContext() {
            return E
        },
        setContents(html: string) {
            E.setContents(html)
        },
        getValue() {
            return E.getContext().element.wysiwyg.innerHTML
        }
    })
}